import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import style from './style.module.scss';

class Home extends React.PureComponent {
  render() {
    const { t } = this.props;
    return (
      <div className={style.container}>{t('welcome')}</div>
    );
  }
}

Home.propTypes = {
  t: PropTypes.func.isRequired
};

export default withTranslation(['home'])(Home);
